import { Box, Button, Input, Text, VStack } from "@chakra-ui/react";
import { t } from "i18next";
import React, { startTransition, useState } from "react";
import { COUNTRIES as data, ICountry } from "./countries";

export type IProps = {
	onChange: (args: ICountry) => void;
};

export function SearchCountry({ onChange }: IProps) {
	const [filteredList, setFilteredList] = useState(data);

	const handleSearch = (event: React.ChangeEvent<HTMLInputElement>) => {
		const value = event.target.value.toLowerCase();
		const result =
			data.filter((item) => {
				return item.name.toLowerCase().includes(value);
			}) || [];

		startTransition(() => {
			setFilteredList(result);
		});
	};

	return (
		<Box
			mt={1}
			maxH="xs"
			bg="white"
			width="full"
			zIndex="popover"
			height="auto"
			overflow="auto"
			borderRadius="lg"
			position="absolute"
			shadow="md"
		>
			<Box position="sticky" top="0" padding={4} bg="white" zIndex="popover">
				<Input
					size="sm"
					type="search"
					borderRadius="md"
					autoComplete="off"
					placeholder={t("Search a country...")}
					onChange={(event) => handleSearch(event)}
				/>
			</Box>
			<VStack w="full" gap={2} p={2}>
				{filteredList?.map((item: ICountry) => (
					<Button
						variant="unstyled"
						w="full"
						display="grid"
						gridTemplateColumns="auto 1fr"
						textAlign="left"
						key={item.code + item.name}
						paddingY={2}
						cursor="pointer"
						fontWeight={500}
						textTransform="capitalize"
						onClick={() => {
							onChange(item);
						}}
						style={{ transition: "all .125s ease" }}
					>
						<Text as="span" mx={4}>
							{item?.flag}
						</Text>
						<Text as="span">{item?.name}</Text>
					</Button>
				))}
			</VStack>
		</Box>
	);
}
